import {CatalogItemSidebarDetailsStore, VipLocalStore} from '@modules'
import {computed, observable, Fuse, React} from '@api'
import {TABS_TYPE, EmersyaViewerStore, CatalogItemCarouselStore} from '@design-board/stores'
import {synchronizeStores} from '@stores/SynchronizeStores'
import {action, autorun, reaction} from 'mobx'
import {DetailsViewFieldConfig, DetailsSectionConfig, StoresInstance} from '@stores'
import {IDisposer} from 'mobx-utils'

export interface IModalDetailSearchResult {
  id: string
  label: string
  type: 'field' | 'tab' | 'titleField' | 'section'
  tab?: string
  index?: number
}

export class SidebarModalStore extends VipLocalStore{
  @observable.ref extraTabHeader: React.ReactNode
  @observable.ref emersya: EmersyaViewerStore
  @observable.ref carousel: CatalogItemCarouselStore

  constructor(stores: StoresInstance, public details: CatalogItemSidebarDetailsStore) {
    super(stores)

    this._toDispose.push(
      autorun(() => {
        const {searchableData, config: {tabs}, details: {data}} = this

        this.setupSearcher()
      }),
      reaction(() => this.details?.sidebar?.open, () => {
        const {isModal, config: {tabs}, details: {sidebar: {selectedTab}}} = this
        if (isModal && tabs?.length) {
          if (!tabs.some(t => t.id == selectedTab)) {
            //debugger
            this.details.sidebar.tab = 0
          }
        }
      }, {name: `Reset tab when no longer available`}))
  //  })
  }

  _toDispose: Array<IDisposer> = []
  @action dispose = () => this._toDispose.forEach(d => d())

  fieldsToSearchableData = ({tab, data, index, path, fields, sections}: { tab: string, data: any, index?: number, path?: string, sections?: Array<DetailsSectionConfig>, fields?: Array<DetailsViewFieldConfig> }) => {
    const {es, fieldsToSearchableData} = this
    return [
      ..._.flatMap(
        sections || [],
        ({label, fields}, i) => [
          {type: 'section', label: label ? label : null, tab, index: i},
          ..._.flatMap(fieldsToSearchableData({tab, data, fields: _.isArray(fields) ? fields : _.isFunction(fields) ? fields(data, this.stores) : null}))
        ]),
      ...(fields || []).map(({field, fields: childFields, label, titleField}) => {
        const v = es.readField(data, field)
        if (_.isArray(v.val)) {
          if (childFields) {
            return _.flatMap(v.val.map((entry, i) => ([
              titleField ? {id: titleField, type: 'titleField', index: i, tab, value: es.readField(entry, titleField)?.valAsString} : null,
              ...fieldsToSearchableData({tab, data: entry, index: i, fields: _.isArray(childFields) ? childFields : _.isFunction(childFields) ? childFields(data, this.stores) : null, path: `${field}[${i}].`})
            ].filter(_.identity))))
          }
          return null
        } else {
          return [
            {
              id: `${path ?? ''}${field}`,
              label: label ? label : null,
              index,
              type: 'field',
              tab,
              value: v?.valAsString
            },
            titleField ? {id: `${path ?? ''}${titleField}`, type: 'titleField', tab, value: es.readField(data, titleField)?.valAsString} : null
          ].filter(_.identity)
        }
      })
    ]
  }

  @computed get searchableData() {
    const {details: {data}, config, isModal, fieldsToSearchableData} = this
    if (!isModal || !data) return []
    const searchable = _.flatMap(_.flatMap(config?.tabs?.map(
        ({id: tab, label, sections, fields}) => (
            [
              {id: tab,
                tab,
                label: label ? label : _.capitalize(tab), type: 'tab'},
              ..._.flatMap(fieldsToSearchableData({tab, data, fields, sections}))
            ]
        ))).filter(_.identity))
    return searchable
  }

  @action private setupSearcher = () => {
    const {searchableData, isModal} = this

    this.searcher = !isModal
                    ? null
                    : new Fuse(
        searchableData,
        {
          keys: ['label', 'value'],
          isCaseSensitive: false, shouldSort: false, threshold: .2
        })
  }

  @computed get searchResults(): Array<IModalDetailSearchResult> {
    const {searcher, details: {sidebar: {searchText: label}}} = this
    return !searcher || !label ? [] : searcher.search({ label })
  }

  @observable.ref searcher: Fuse<{}, {}>

  @computed get isModal() {
    return this.details.sidebar.type == 'modal' && !_.isEmpty(this.config)
  }

  // @computed get queryParams() {
  //   const {isModal, searchValue} = this
  //   if (!isModal) return {}
  //
  //   return {
  //     searchValue
  //   }
  // }

  get config() {
    return this.details?.detailDef?.modal ?? {}
  }

  get hasSecondariesTab () {
    return !!this.config?.tabs?.find(t => t.id === TABS_TYPE.SECONDARIES)
  }

  get hasAdoptionTab () {
    return !!this.config?.tabs?.find(t => t.id === TABS_TYPE.ADOPTION)
  }

  // @computed get title() {
  //   const {config: {title}, details: {data}} = this
  //   return es.readField(data, title?.field)?.val
  // }

  @observable nestedCardsViewMode: 'grid' | 'list' = 'grid'
  @action toggleNestedCardsViewMode = () => this.nestedCardsViewMode = this.nestedCardsViewMode == 'grid' ? 'list' : 'grid'
  @action onSetNestedCardsViewMode = (mode) => () => this.nestedCardsViewMode = mode
}



// WEBPACK FOOTER //
// ./src/modules/drawer/stores/SidebarModalStore.ts